import React from 'react'; // eslint-disable-line
import './HorizontalSeparator.scss';

const HorizontalSeparator = () => {
  return(
    <div className="horizontal-separator" >
      <div className="horizontal-separator__line"/>
    </div>
  )
}

export default HorizontalSeparator
